import { UNCLASSIFIED_CODE } from "@/domain/types";
import { getViewValueStyle } from "@/domain/views";
import { useI18n } from "@/i18n/useI18n";
import type { MatrixModel } from "./useMatrixModel";

/** Legend for the classification values currently shown in the matrix. */
export function Legend({ model }: { model: MatrixModel }) {
  const i18n = useI18n();
  const { view, legendCodes } = model;
  return (
    <div id="legend" className="legend">
      <strong>{i18n.t("forklaring")}</strong>
      <br />
      <br />
      {legendCodes.map((code) =>
        code === UNCLASSIFIED_CODE ? (
          <div key={code} className="legend-item">
            <span className="legend-color legend-unclassified" />
            <span className="legend-text">{i18n.t("unclassifiedItems")}</span>
          </div>
        ) : (
          <div key={code} className="legend-item">
            <span className="legend-color" style={getViewValueStyle(view.values[code])} />
            <span className="legend-text">{i18n.viewValueLabel(view, code)}</span>
          </div>
        ),
      )}
    </div>
  );
}
